import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a6b52dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Entrar")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Entrar com o Google")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBtn = _resolveComponent("AppBtn")!
  const _component_AuthFormLink = _resolveComponent("AuthFormLink")!
  const _component_DefaultLoading = _resolveComponent("DefaultLoading")!
  const _component_DefaultNotification = _resolveComponent("DefaultNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event))
      }, null, 512), [
        [_vModelText, _ctx.formData.email]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event))
      }, null, 512), [
        [_vModelText, _ctx.formData.password]
      ]),
      _createVNode(_component_AppBtn, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_AppBtn, {
        onClick: _ctx.handleClick,
        type: "button"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_AuthFormLink, {
        text: "Ainda não em cadastro?",
        textLink: "Cadastre-se",
        to: { name: 'Welcome', params: { mode: 'signup' } }
      }),
      _createVNode(_component_AuthFormLink, {
        text: "Esqueceu a senha?",
        textLink: "Redefina",
        to: { name: 'Welcome', params: { mode: 'reset' } }
      })
    ], 32),
    _createElementVNode("div", null, [
      (_ctx.isPending)
        ? (_openBlock(), _createBlock(_component_DefaultLoading, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_DefaultNotification, {
        type: _ctx.notification.type,
        text: _ctx.notification.msg
      }, null, 8, ["type", "text"])
    ])
  ]))
}